'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = 'M380.4 374.6C471.5 283.5 505.1 83.7 512 0 428.3 6.9 228.5 40.5 137.4 131.6l-6.3 6.6c-61 66.1-97.3 182.3-37.5 257.6L3 486.4 25.6 509 116.2 418.4c75.3 59.8 191.5 23.5 257.6-37.5l6.6-6.3zM139 395.6l43.6-43.6 175.1 0c-29.6 29.6-73.7 53.9-118 62-38 7-73.3 1.8-100.7-18.4zM384 320l-169.3 0 64-64 140 0c-10.2 23.5-21.7 45.2-34.6 64zm47.4-96l-120.7 0 48.9-48.9-22.6-22.6-220.5 220.5c-20.3-27.5-25.4-62.7-18.4-100.7 8.2-44.3 32.4-88.3 62-118l7.8-7.3c40.2-36 102.6-63 168.6-82 50.4-14.5 100.5-23.7 139.5-28.8-5.2 39-14.3 89.1-28.8 139.5-4.7 16.4-10 32.6-15.7 48.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;